import { render, staticRenderFns } from "./FacetRelatedCategories.vue?vue&type=template&id=75c71d0e&"
import script from "./FacetRelatedCategories.vue?vue&type=script&lang=js&"
export * from "./FacetRelatedCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports